import '../index.html';

import fscreen from 'fscreen';

import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/draggable';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';

import Ladda from 'ladda';
import 'ladda/dist/ladda-themeless.min.css';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/eclipse.css';

import CodeMirror from 'codemirror';
import 'codemirror/mode/clike/clike';
import './codemirror-modes/tessla';
import './codemirror-modes/tessla-stream';
import 'codemirror/addon/edit/matchbrackets';

import './style.css';

import {visualizer} from "tessla-visualizer";

import { WS_BASE_ADDRESS, loadExampleFile } from './config';

$(function () {
  $('#infoModal').modal('show');

  var GUTTER_ID = "tessla-ws-markers";
  var CLOSE_CONFIRMATION_MESSAGE = "Changes that you made may not be saved. Continue?";
  var dirty = false;
  var currentExample = {
    concrete: {
      tessla: "",
      input: ""
    },
    abstract: {
      tessla: "",
      input: ""
    }
  }
  
  var inputEditor = CodeMirror.fromTextArea($("#input")[0], {
    theme: 'eclipse',
    lineNumbers: true,
    matchBrackets: true,
    mode: "text/x-tessla-stream",
    gutters: [GUTTER_ID]
  });
  var tesslaEditor = CodeMirror.fromTextArea($("#tessla-code")[0], {
    theme: 'eclipse',
    lineNumbers: true,
    matchBrackets: true,
    mode: "text/x-tessla",
    gutters: [GUTTER_ID]
  });
  var outputEditor = CodeMirror.fromTextArea($("#output")[0], {
    theme: 'eclipse',
    lineNumbers: true,
    mode: "text/x-tessla-stream"
  });
  outputEditor.autoscroll = true;
  var statusEditor = CodeMirror.fromTextArea($("#status")[0], {
    theme: 'eclipse',
    lineNumbers: true,
    mode: "text/plain",
    readOnly: true
  });
  statusEditor.autoscroll = true;

  var visu;

  $(window).resize(function () {
    if (visu && $('#switchVisualizer').hasClass('active')) {
      visu.resize();
    }
  });

  $('#brushOutput button').click(function () {
    var button = $(this);
    if (button.hasClass('btn-primary')) {
      // disable brush
      button.removeClass('btn-primary').addClass('btn-outline-primary');
      visu.disableBrush();
      visu.showArrows();
    } else {
      // enable brush
      button.removeClass('btn-outline-primary').addClass('btn-primary');
      visu.enableBrush();
    }
  });

  function parse_traces(editor, styles) {
    var streams = {};
    editor.eachLine(function (line) {
      var text = line.text;
      if (text.indexOf('$timeunit') === 0) return;
      var matches;
      if (matches = text.match(/(\d+): (.+) = (.+)/)) {
        var e = {time: +matches[1], value: matches[3]};
        var m;
        if (m = e.value.match(/^Some\((.+)\)$/)) {
          e.value = m[1];
        } else if (e.value === "None") {
          e.value = "⊤";
          e.color = "#ff8c00";
        } else if (m = e.value.match(/^"(\d+\.\.\d+)"$/)) {
          e.value = m[1];
        }
        if (e.value === "true") {
          e.value = true;
          e.color = "#00dd00";
        } else if (e.value === "false") {
          e.value = false;
          e.color = "#ff0000";
        } else if (e.value === "()") {
          e.value = undefined;
        } else if (!isNaN(e.value)) {
          e.value = +e.value;
        }
        var name = matches[2];
        if (!streams[name]) {
          streams[name] = [];
        }
        streams[name].push(e);
      }
    });
    var result = [];
    Object.keys(streams).forEach(function(key) {
      var values = streams[key];
      var stream = {name: key, style: "events", data: values};
      if (styles[stream.name]) {
        stream.style = styles[stream.name];
      }
      result.push(stream);
    });
    return result;
  }

  function find_outputs(editor) {
    var outputs = [];
    editor.eachLine(function (line) {
      var text = line.text;
      var matches, name, type;
      if (matches = text.match(/^\s*out\s+(?:.+\s+as\s+)?([a-zA-Z_][a-zA-Z_0-9]*(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*)(?:\s*#\s*(signal|dots|plot|events|unit events|bubbles))?/)) {
        name = matches[1];
        type = matches[2];
        outputs.push({name: name, type: type});
      }
    });
    return outputs;
  }

  function sort_traces(data, order) {
    data.sort(function (a, b) {
      return order.indexOf(a.name) - order.indexOf(b.name);
    });
  }

  $('#switchTessla').click(function (event) {
    event.preventDefault();
  });

  $('#switchAbstract').click(function (event) {
    event.preventDefault();
    if (dirty) {
      if (!confirm(CLOSE_CONFIRMATION_MESSAGE)) {
        return;
      }
    }
    $('#switchSpecification').removeClass('active');
    $('#switchAbstract').addClass('active');
    $('#switchOutput').click();
    clearHints();
    [outputEditor, statusEditor, tesslaEditor, inputEditor].forEach(function (editor) {
      editor.setValue('');
    });
    dirty = false;
    tesslaEditor.setValue(currentExample.abstract.tessla);
    inputEditor.setValue(currentExample.abstract.input);
  });  

  $('#switchSpecification').click(function (event) {
    event.preventDefault();
    if (dirty) {
      if (!confirm(CLOSE_CONFIRMATION_MESSAGE)) {
        return;
      }
    }
    $('#switchAbstract').removeClass('active');
    $('#switchSpecification').addClass('active');
    $('#switchOutput').click();
    clearHints();
    [outputEditor, statusEditor, tesslaEditor, inputEditor].forEach(function (editor) {
      editor.setValue('');
    });
    dirty = false;
    tesslaEditor.setValue(currentExample.concrete.tessla);
    inputEditor.setValue(currentExample.concrete.input);
  });

  $('#switchTessla').dblclick(function (event) {
    $('#expandInput').click();
  });

  $('#switchSpecification,#switchAbstract').dblclick(function (event) {
    $('#expandSpecification').click();
  });

  $('#switchStatus').click(function (event) {
    event.preventDefault();
  });

  $('#switchStatus').dblclick(function (event) {
    $('#expandStatus').click();
  });

  $('#switchVisualizer').click(function (event) {
    event.preventDefault();
    var outputs = find_outputs(tesslaEditor);
    var outputStyles = {};
    outputs.forEach(function (o) {
      outputStyles[o.name] = o.type;
    });
    var outputOrder = outputs.map(function (o) { return o.name });
    var data = parse_traces(outputEditor, outputStyles);
    if (data.length > 0) {
      $('#switchVisualizer').addClass('active');
      $('#switchOutput').removeClass('active');
      $(outputEditor.getWrapperElement()).hide();
      $('#visualizer').show();
      $('#brushOutput').show();
      $('#autoscrollOutput').hide();
      sort_traces(data, outputOrder);
      if (visu) {
        visu = undefined;
        $('#visualizer svg').html('');
      }
      visu = visualizer('#visualizer svg', {streams: data});
    } else {
      $('#switchOutput').click();
      alert("Please run the specification first.");
    }
  });

  $('#switchOutput').click(function (event) {
    $('#switchVisualizer').removeClass('active');
    $('#switchOutput').addClass('active');
    $(outputEditor.getWrapperElement()).show();
    $('#visualizer').hide();
    $('#brushOutput').hide();
    $('#autoscrollOutput').show();
    visu = undefined;
    $('#visualizer svg').html('');
    event.preventDefault();
  });

  $('#switchVisualizer, #switchOutput').dblclick(function (event) {
    $('#expandOutput').click();
  });

  var ladda = Ladda.create($("#run")[0]);
  function enable() {
    $("#run").removeAttr("disabled");
    ladda.stop();
    $('#cancel').stop().fadeOut('fast');
    tesslaEditor.setOption("readOnly", false);
  }
  function disable() {
    $("#run").attr("disabled","disabled");
    ladda.start();
    $('#cancel').stop().fadeIn('fast');
    tesslaEditor.setOption("readOnly", "nocursor");
  }

  var cHints = {gutters: {}, markers: []};
  var tesslaHints = {gutters: {}, markers: []};
  var inputHints = {gutters: {}, markers: []};

  function clearHints() {
    clearEditorHints(tesslaEditor, tesslaHints);
    clearEditorHints(inputEditor, inputHints);
  }

  function clearEditorHints(editor, hints) {
    hints.markers.forEach(function(marker) {marker.clear();});
    hints.markers = [];
    editor.clearGutter(GUTTER_ID);
    hints.gutters = {};
    $('.tooltip').remove();
  }

  tesslaEditor.on('change', function () {
    clearEditorHints(tesslaEditor, tesslaHints);
  });

  [outputEditor, tesslaEditor, inputEditor].forEach(function (editor) {
    editor.on('inputRead', function () {
      dirty = true;
    });
  });

  function makeMarker(severity, multiple) {
    var marker = document.createElement("div"), inner = marker;
    marker.className = "tessla-ws-marker-" + severity;
    if (multiple) {
      inner = marker.appendChild(document.createElement("div"));
      inner.className = "tessla-ws-marker-multiple";
    }
    return marker;
  }

  function showTesslaHint(severity, startLine, startCh, endLine, endCh, title) {
    showHint(tesslaEditor, tesslaHints, severity, startLine, startCh, endLine, endCh, title);
  }

  function showInputHint(severity, startLine, startCh, endLine, endCh, title) {
    showHint(inputEditor, inputHints, severity, startLine, startCh, endLine, endCh, title);
  }

  var textMarkerId = 0;

  function showHint(editor, hints, severity, startLine, startCh, endLine, endCh, title) {
    textMarkerId += 1;
    hints.markers.push(editor.markText({line: startLine, ch: startCh}, {line: endLine, ch: endCh}, {className: 'tessla-ws-mark-' + textMarkerId + ' tessla-ws-mark-' + severity}));
    $('.' + 'tessla-ws-mark-' + textMarkerId).tooltip({placement: 'bottom', title: title, container: 'body'});
    var gutter;
    if (hints.gutters[startLine]) {
      gutter = hints.gutters[startLine];
      if (gutter.severity == 'warning') {
        gutter.severity = severity;
      }
      gutter.multiple = true;
      gutter.title += "\n" + title;
    } else {
      gutter = hints.gutters[startLine] = {
        severity: severity,
        title: title
      };
    }
    var marker = makeMarker(gutter.severity, gutter.multiple);
    editor.setGutterMarker(startLine, GUTTER_ID, marker);
    $(marker).tooltip({placement: 'right', title: gutter.title, container: 'body'});
  }

  function parseTesslaError(severity, line) {
    var match, file, severity, startLine, startCh, endLine, endCh, title;
    if (match = line.match(/^([^(]+)\((\d+),(\d+) - (\d+),(\d+)\): (.+)$/)) {
      file = match[1];
      startLine = match[2];
      startCh = match[3];
      endLine = match[4];
      endCh = match[5];
      title = match[6];
      startLine = +startLine - 1;
      startCh = +startCh - 1;
      endLine = +endLine - 1;
      endCh = +endCh - 1;
      if (file === 'input') {
        showInputHint(severity, startLine, startCh, endLine, endCh, title);
      } else {
        showTesslaHint(severity, startLine, startCh, endLine, endCh, title);
      }
    }
  }

  var ws;

  function ws_onmessage(m) {
    var data = JSON.parse(m.data);

    switch (data.kind) {
      case 'finish': // end of transmission for this command
        enable();
        return;

      case 'warning': // tessla compile warning
        parseTesslaError('warning', data.value);
        addLine(statusEditor, data.value, data.kind);
        return;

      case 'exception': // tessla runtime error / tessla runtime exception
      case 'error': // tessla compile error
        parseTesslaError('error', data.value);
        addLine(statusEditor, data.value, data.kind);
        return;

      case 'status': // status messages of the web service
        addLine(statusEditor, data.value, data.kind);
        return;

      case 'trace': // tracing output
      case 'output': // tessla output
        addLine(outputEditor, data.value);
        return;

      default:
        console.error("Strange response", data);
        return;
    } 
  }

  function addLine(editor, line, kind) {
    if (kind) {
      line = kind.padEnd(10).toUpperCase() + line;
    }
    editor.replaceRange(line + "\n", CodeMirror.Pos(editor.lastLine()));
    if (editor.autoscroll) {
      editor.scrollTo(null, 100000);
    }
  }

  function ws_onopen() {
    sendData();
  }

  function sendData() {
    var tessla = tesslaEditor.getValue();
    var input = inputEditor.getValue();
    var data = JSON.stringify({command: 'run', input: input, specification: tessla});
    ws.send(data);
  }

  function ws_onerror() {
    ws = undefined;
    enable();
    alert("Unable to connect to TeSSLa webservice.");
  }

  function ws_onclose() {
    ws = undefined;
    enable();
  }

  $("#run").click(function (event) {
    clearHints();
    disable();
    outputEditor.setValue('');
    $('#switchOutput').click();
    statusEditor.setValue('');
    if (!ws) {
      ws = new WebSocket(WS_BASE_ADDRESS + "tessla");
      ws.onopen = ws_onopen;
      ws.onclose = ws_onclose;
      ws.onerror = ws_onerror;
      ws.onmessage = ws_onmessage;
    } else {
      sendData();
    }
    event.preventDefault();
  });

  function cancel() {
    if (ws) {
      ws.close();
    }
  }

  $("#cancel").click(function (event) {
    cancel();
    event.preventDefault();
  });

  function loadExample(menuItem) {
    if (dirty) {
      if (!confirm(CLOSE_CONFIRMATION_MESSAGE)) {
        return;
      }
    }
    clearHints();
    compressAllEditors();
    [outputEditor, statusEditor, tesslaEditor, inputEditor].forEach(function (editor) {
      editor.setValue('');
    });
    dirty = false;
    $('#switchOutput').click();
    $('#switchAbstract').removeClass('active');
    $('#switchSpecification').addClass('active');
    loadExampleFile(menuItem.concrete.tessla, function success(content) {
      currentExample.concrete.tessla = content;
      tesslaEditor.setValue(currentExample.concrete.tessla);
    });
    loadExampleFile(menuItem.concrete.input, function success(content) {
      currentExample.concrete.input = content;
      inputEditor.setValue(currentExample.concrete.input);
    });
    loadExampleFile(menuItem.abstract.tessla, function success(content) {
      currentExample.abstract.tessla = content;
    });
    loadExampleFile(menuItem.abstract.input, function success(content) {
      currentExample.abstract.input = content;
    });
  }

  function addExample(menuItem) {
    if (menuItem.separator) {
      $('#examples').append('<div class="dropdown-divider"></div>');
    } else if (menuItem.title) {
      var link = $('<a class="dropdown-item" href>' + menuItem.title + '</a>');
      link.click(function (event) {
        loadExample(menuItem);
        event.preventDefault();
      });
      $('#examples').append(link);
    }
  }

  loadExampleFile('index.json', function success(content) {
    var data = JSON.parse(content);
    if (data.examples && data.examples.forEach) {
      data.examples.forEach(function(item) {
        addExample(item);
      });
      loadExample(data.examples[0]);
    }
  });

  $("#fullscreen").click(function () {
    if (fscreen.fullscreenElement) {
      fscreen.exitFullscreen();
    } else {
      fscreen.requestFullscreen(document.documentElement);
    }
  });

  fscreen.addEventListener('fullscreenchange', function () {
    var button = $("#fullscreen");
    var icon = button.find('i');
    if (fscreen.fullscreenElement) {
      icon.attr('class', 'fa fa-compress');
      button.removeClass('btn-outline-light').addClass('btn-light');
    } else {
      icon.attr('class', 'fa fa-expand');
      button.removeClass('btn-light').addClass('btn-outline-light');
    }
  });

  function compressAllEditors() {
    var buttons = $('.btn-expand');
    var icons = buttons.find('i');
    icons.attr('class', 'fa fa-expand');
    buttons.removeClass('btn-primary').addClass('btn-outline-primary');
    $('.row').removeClass('row-active').show();
    $('.editor-col').removeClass('col-md-12').addClass('col-md-6').show();
  }

  $('.btn-expand').click(function () {
    var button = $(this);
    var icon = button.find('i');
    var col = button.closest('div.editor-col');
    var row = col.closest('div.row');
    if (icon.hasClass('fa-expand')) {
      icon.attr('class', 'fa fa-compress');
      button.removeClass('btn-outline-primary').addClass('btn-primary');
      $('div.editor-col, div.row').hide();
      row.addClass('row-active').show();
      col.show().removeClass('col-md-6').addClass('col-md-12');
    } else {
      compressAllEditors();
    }
  });

  $('#expandOutput').click(function (event) {
    if (visu && $('#switchVisualizer').hasClass('active')) {
      visu.resize();
    }
  });

  function editorByName(name) {
    switch (name) {
      case 'input': return inputEditor;
      case 'tessla': return tesslaEditor;
      case 'output': return outputEditor;
      case 'status': return statusEditor;
    }
  }

  $('.btn-autoscroll').click(function () {
    var button = $(this);
    var editor = editorByName(button.data('target'));
    if (button.hasClass('btn-outline-primary')) {
      button.addClass('btn-primary').removeClass('btn-outline-primary');
      editor.autoscroll = true;
      editor.scrollTo(null, 100000);
    } else {
      button.removeClass('btn-primary').addClass('btn-outline-primary');
      editor.autoscroll = false;
    }
  });

  window.addEventListener("beforeunload", function (e) {
    if (dirty) {
      var confirmationMessage = CLOSE_CONFIRMATION_MESSAGE;
      (e || window.event).returnValue = confirmationMessage;     //Gecko + IE
      return confirmationMessage;                                //Webkit, Safari, Chrome etc.
    }
  });
});



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 178
// module chunks = 0